export enum ModalId {
  UPDATE_CIG_NOTE_CONFIRMATION_DIALOG = "update-cig-note-confirmation-dialog",
  NAR_LETTER_MODAL = "nar-letter-modal",
  INSURANCE_ERROR_DIALOG = "insurance-error-dialog",
  IMAGE_VIEWER_MODAL = "image-viewer-modal",
  BO_VALUES_MODAL = "bo-values-modal",
  STATUS_UPDATE_MODAL = "status-update-modal",
  DOC_VIEWER_MODAL_WITH_TITLE = "doc-viewer-modal-with-title",
  DOC_VIEWER_MODAL = "doc-viewer-modal",
  DOC_VIEWER_WITH_SIDE_NAVIGATION = "doc-viewer-with-side-navigation",
  AUTH_INACCURACY_MODAL = "auth-inaccuracy-modal",
  FINAL_DOCUMENT_MODAL = "documents-modal",
  FORM_SELECTION_MODAL = "form-selection-modal",
  ANALYTICS_DATE_PICKER_MODAL = "analytics-date-picker-modal",
  API_RESPONSE_VIEWER_MODAL = "api-response-viewer-modal",
  TRIGGER_RPA_MODAL = "trigger-rpa-modal",
  TRIGGER_RPA_MODAL_NEW = "trigger-rpa-modal-new",
  COMMENT_RPA_MODAL_NEW = "comment-rpa-modal-new",
  STATUS_CHANGED_TO_HOLD_MODAL = "status-changed-to-hold-modal",
  HAPPY_FLOW_MODAL = "happy-flow-modal",
  CLINICAL_DATA_TABLE = "clinical-data-table",
  NAR_GRID_MODAL = "nar-grid-modal",
  TRIGGER_RPA_WITH_DOC_LIST_MODAL = "trigger-rpa-with-doc-list-modal",
  NAR_RPA_TRIGGER_MODAL = "nar-rpa-trigger-modal",
  IMAGE_VIEWER_WITH_BADGES_MODAL = "image-viewer-with-badges-modal",
  TOGGLE_SWITCH_CONFIRMATION_DIALOG = "toggle-switch-confirmation-dialog",
  ORDER_PROCESSING_INFO_MODAL = "order-processing-info-modal",
  DRAFT_SUBMISSION_MODAL = "draft-submission-modal",
  SUBMISSION_SUMMARY_MODAL = "submission-summary-modal",
  PUSH_TO_SFTP_MODAL = "push-to-sftp-modal",
  SFTP_STATUS_MODAL = "sftp-status-modal",
  CASE_INITIATION_MODAL = "case-initiation-modal",
  CASE_INITIATION_UPLOAD_MODAL = "case-initiation-upload-modal",
  PRIMARY_CARE_PDF_MODAL = "primary-care-pdf-modal",
  PRIMARY_CARE_CMM_SCREENSHOT_MODAL = "primary-care-cmm-screenshot-modal",
  SEND_TO_PLAN_CONFIRM_MODAL = "send-to-plan-confirm-modal",
  EXPANDABLE_TABLE_ROW_MEDICATION_MODAL = "expandable-table-row-medication-modal",
  EXPANDABLE_TABLE_ROW_INSURANCE_MODAL = "expandable-table-row-insurance-modal",
  EXPANDABLE_TABLE_ROW_DOSAGE_MODAL = "expandable-table-row-dosage-modal",
  EXPANDABLE_TABLE_ROW_DIAGNOSIS_MODAL = "expandable-table-row-diagnosis-modal",
  EXPANDABLE_TABLE_ROW_SECONDARY_DIAGNOSIS_MODAL = "expandable-table-row-secondary-diagnosis-modal",
  CMM_INPUT_VIEWER_MODAL = "cmm-input-viewer-modal",
  REPORT_PRESCRIPTION_MODAL = "report-prescription-modal",
  REPORT_MEDICATION_INACCURACY_MODAL = "report-medication-inaccuracy-modal",
  SFTP_DOC_MODAL = "sftp-doc-modal",
  TEXT_NOTE_UPLOAD = "text-note-upload",
  TEXT_NOTE_DOC = "text-note-doc",
  LETTER_UPLOAD_DOC = "letter-upload-doc",
  SFTP_RERUN_MODAL = "sftp-rerun-modal",
  DRUG_LABEL_MODAL = "drug-label-modal",
  SFTP_PUSH_PENDING_RECORDS_MODAL = "sftp-push-pending-records-modal",
  ASTERA_SUBMISSION_MODAL = "astera-submission-modal",
  EXPORT_MODAL = "export-modal",
  EXPORT_SELECTED_CONFIRM_MODAL = "export-selected-confirm-modal",
  EXPORT_CSV_ERROR_MODAL = "export-csv-error-modal",
  SFTP_SUMMARY_MODAL = "sftp-summary-modal",
  ADD_FORM_MATRIX_DIALOG = "add-form-matrix-dialog",
  ADD_NEW_LOGIC_MODAL = "add-new-logic-modal",
  CONDITION_LIST_TOP_VALUES_MODAL = "condition-list-top-values-modal",
  ASTERA_TRACK_STATUS_MODAL = "astera-track-status-modal",
  DOWNLOAD_FILES_MODAL = "download-files-modal",
  ASTERA_PRIMARY_CARE_SUBMISSION_MODAL = "astera-primary-care-submission-modal",
  PRIMARY_CARE_TRACK_STATUS_MODAL = "primary-care-track-status-modal",
  PROVIDER_OPTION_FORM_MODAL = "provider-option-form-modal",
  DELETE_PROVIDER_OPTION_CONFIRM = "delete-provider-option-confirm",
  ADD_MN_RULE_MODAL = "add-mn-rule-modal",
  ADD_NEW_CALLING_RULE_MODAL = "add-new-calling-rule-modal",
  ADD_NEW_POC_ASSIGNMENT_MODAL = "add-new-poc-assignment-modal",
  ADD_NEW_POC_REASSIGNMENT_MODAL = "add-new-poc-reassignment-modal",
  ADD_NEW_USER_MODAL = "add-new-user-modal",
  ADD_GROUP_MODAL = "add-group-modal",
  UPDATE_GROUP_MODAL = "update-group-modal",
  STAT_FILE_UPLOAD_MODAL = "stat-file-upload-modal",
  REASSIGN_CASE_MODAL = "reassign-case-modal",
  SUBMISSION_SUMMARY_SIDE_PANEL = "submission-summary-side-panel",
}
